<template>
<div class="chapter">
<div class="inner_page">
<p class="fm">Acknowledgements</p>
<p class="noindent">My debt to the historians listed in the bibliography is evident. I hope that this introduction to the guerrilla war in Missouri will make the reader want to learn more about the subjects these authors have explored in depth.</p>
<p class="indent">I want to acknowledge the assistance of Sara Przybylski at the State Historical Society of Missouri at Columbia, Missouri, and Dorris Keeven-Franke at the St. Charles Historical Society for their help in obtaining photographs and illustrations for this book. I also want to thank Colter Sikora for the excellent maps.</p>
<p class="indent">Finally, I must give the most credit to my wife, Vicki. Without her encouragement, suggestions and, yes, prodding, this book would never have been conceived, let alone completed. Thanks, Vicki, I love you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?e6f1b754